import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import Form from "react-bootstrap/Form";

import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";

import ThemeProvider from "react-bootstrap/ThemeProvider";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faHomeUser,
  faUserGraduate,
  faUserDoctor,
  faUserNurse,
  faUserNinja,
  faUserAstronaut,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

function Profile() {
  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      <Container fluid="xxs">
        <Navbar id="container-nav" expand="lg">
          <Container fluid>
            <Navbar.Brand href="#">
              <Link to="/profile" aria-current="page">
                <FontAwesomeIcon icon={faHomeUser} className="user-icon" />
              </Link>
            </Navbar.Brand>
            <Navbar.Brand>
              <Link to="/userone" aria-current="page" id="name">
                DROP Cycling&trade;
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="navbarScroll"
              className="navbar-toggler"
              id="border"
            >
              <FontAwesomeIcon icon={faBars} id="toggle" />
            </Navbar.Toggle>
            <Navbar.Collapse id="navbarScroll">
              <Nav
                className="me-auto my-2 my-lg-0"
                style={{ maxHeight: "100px" }}
                navbarScroll
              ></Nav>
              <Form className="d-flex" id="search">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  className="me-2"
                  aria-label="Search"
                />
                <Button variant="outline-none" id="search-btn">
                  Search
                </Button>
              </Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className="user">
          <Row className="g-4">
            <Col sm={{ span: 10, offset: 1 }}>
              <p className="crew-pagination">
                <FontAwesomeIcon icon={faUsers} />
              </p>
            </Col>
          </Row>

          <Card className="card-design-crew">
            <Row className="g-4">
              <Col sm={{ span: 12 }}>
                <p className="sub-topic-crew">Crew</p>
              </Col>
            </Row>
          </Card>
          <Card className="card-design-crew-two">
            <Row>
              <Col sm={{ span: 12 }}>
                <p className="crew-header">Holeshot</p>

                <p className="basic-text-crew">
                  <FontAwesomeIcon icon={faUserGraduate} id="icon-space-crew" />
                  Name: Zara Thomson | Age: 25 | Origin: England
                </p>
                <p className="basic-text-crew">
                  <FontAwesomeIcon icon={faUserDoctor} id="icon-space-crew" />
                  Name: Sam Beck | Age: 33 | Origin: Germany
                </p>
                <p className="basic-text-crew">
                  {" "}
                  <FontAwesomeIcon icon={faUserNurse} id="icon-space-crew" />
                  Name: Benjamin Peterson | Age: 25 | Origin: USA
                </p>
                <p className="basic-text-crew-divide">
                  {" "}
                  <FontAwesomeIcon icon={faUserNinja} id="icon-space-crew" />
                  Name: Matilda Davies | Age: 36 | Origin: England
                </p>
                <p className="crew-header">Chasers</p>
                <p className="basic-text-crew">
                  <FontAwesomeIcon
                    icon={faUserAstronaut}
                    id="icon-space-crew"
                  />
                  Name: Natalie Wallner | Age: 30 | Origin: Austria
                </p>
                <p className="basic-text-crew">
                  <FontAwesomeIcon
                    icon={faUserAstronaut}
                    id="icon-space-crew"
                  />
                  Name: Phillip Perry | Age: 24 | Origin: USA
                </p>
                <p className="basic-text-crew-divide">
                  <FontAwesomeIcon
                    icon={faUserAstronaut}
                    id="icon-space-crew"
                  />
                  Name: Valentina Klein | Age: 27 | Origin: Germany
                </p>
              </Col>
            </Row>
          </Card>
          <footer>
            <Row>
              <Col sm={{ span: 6, offset: 3 }}>
                <p className="copy">Copyright &copy; 2023</p>
              </Col>
            </Row>
          </footer>
        </div>
      </Container>
    </ThemeProvider>
  );
}

export default Profile;
